import axios from "axios";
import config from "./../config";

const api = axios.create({
  baseURL: config.PCNA_SERVICE_URL,
});

const get = (url, data) => api.get(url, { data });
const post = (url, data, headers) => api.post(url, data, { headers: headers });
const update = (url, data) => api.patch(url, data);
const remove = (url) => api.delete(url);

export default {
  get,
  post,
  update,
  remove,
};
